import { useState } from 'react';
import { ChevronDown, Clock, Loader, CheckCircle2 } from 'lucide-react';

const STATUS_META = {
  pending:      { label: 'Pending',     bg: '#FEF3C7', color: '#92400E', Icon: Clock },
  in_progress:  { label: 'In Progress', bg: '#DBEAFE', color: '#1D4ED8', Icon: Loader },
  done:         { label: 'Done',        bg: '#D1FAE5', color: '#065F46', Icon: CheckCircle2 },
};

const OPTIONS = ['pending', 'in_progress', 'done'];

export default function StatusBadge({ status = 'pending', onChange, testId }) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const current = STATUS_META[status] || STATUS_META.pending;
  const { Icon } = current;

  const handleSelect = async (next) => {
    setOpen(false);
    if (next === status) return;
    setSaving(true);
    try {
      await onChange(next);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="relative inline-block" onMouseLeave={() => setOpen(false)}>
      <button
        data-testid={testId}
        type="button"
        disabled={saving}
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition-all hover:opacity-90"
        style={{ backgroundColor: current.bg, color: current.color }}
      >
        <Icon size={12} className={saving ? 'animate-spin' : ''} />
        {current.label}
        <ChevronDown size={11} />
      </button>
      {open && (
        <div
          className="absolute z-20 mt-1 right-0 bg-white rounded-lg shadow-lg border overflow-hidden"
          style={{ borderColor: '#E5E7EB', minWidth: 140 }}
        >
          {OPTIONS.map((opt) => {
            const meta = STATUS_META[opt];
            const OptIcon = meta.Icon;
            return (
              <button
                key={opt}
                data-testid={`${testId}-opt-${opt}`}
                onClick={() => handleSelect(opt)}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-left hover:bg-gray-50 transition-colors"
                style={{ color: meta.color }}
              >
                <OptIcon size={12} />
                {meta.label}
                {opt === status && <span className="ml-auto text-[10px] opacity-60">current</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
